import { useState } from 'react'
import { Popover, Row, Col } from 'antd'
import WizrButton from '../WizrButton'
import MoreIcon from '../../assets/icons/More'
import EditIcon from '../../assets/icons/EditIcon'
import DeleteIcon from '../../assets/icons/DeleteIcon'
import { dispatchDeleteFile, dispatchListFiles, dispatchUpdateFile, dispatchGenerateSASTokenForDownload } from '../../redux/actions/content'
import WizrFlexLayout from '../WizrFlexLayout'
import { useWizrModalContext, MODAL_TYPES } from '../../providers/modal/WizrModalProvider'
import MoveIcon from '../../assets/icons/MoveIcon'
import Copy from '../../assets/icons/Copy'
import DownloadIcon from '../../assets/icons/DownloadIcon'
import VersionHistoryIcon from '../../assets/icons/VersionHistoryIcon'
import { useAuth } from '../../authContext'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'
import { useGetTenantDetails } from '../../redux/selectors/content'
import RefreshIcon from '../../assets/icons/refresh'

interface IFolderActionPopOver {
  detail: any
}

interface IFolderActionPopOverContent {
  details: any
  onEditAction: any
  onDeleteAction: any
  onDownloadAction: any
}

const FileActionPopOverContent = ({
  details,
  onEditAction,
  onDeleteAction,
  onDownloadAction,
}: IFolderActionPopOverContent): JSX.Element => {
  const { hasAcces } = useAuth();
  return (
    <WizrFlexLayout textAlign='left' background='#FFF'>
      <WizrButton
        icon={<EditIcon />}
        text='Edit'
        type='text'
        onClick={onEditAction}
        justifyContent='flex-start'
        disabled={!(details?.upload_status === 'in progress' || hasAcces('update_file'))}
      />
      <WizrButton
        icon={<MoveIcon />}
        text='Move'
        type='text'
        disabled={true}
        justifyContent='flex-start'
      />
      <WizrButton
        icon={<Copy color='#999B9F' />}
        text='Copy'
        type='text'
        disabled={true}
        justifyContent='flex-start'
      />
      <WizrButton
        icon={<DownloadIcon color={details.upload_status === 'success' && details.file_source !== 'Web Page' ? '#000000' : '#999B9F'} />}
        text='Download'
        type='text'
        onClick={onDownloadAction}
        justifyContent='flex-start'
        disabled={!(details.upload_status === 'success') || details.file_source === 'Web Page'}
      />
      <WizrButton
        icon={<VersionHistoryIcon />}
        text='Version History'
        type='text'
        disabled={true}
        justifyContent='flex-start'
      />
      <WizrButton
        icon={<DeleteIcon stroke={details?.upload_status?.toLowerCase().replace(/\s/g, '') === 'inprogress' ? '#999B9F' : '#1D1F22'} />}
        text='Delete'
        type='text'
        disabled={details?.upload_status?.toLowerCase().replace(/\s/g, '') === 'inprogress' || !hasAcces('delete_file')}
        onClick={onDeleteAction}
        justifyContent='flex-start'
      />
      <WizrButton
        icon={<RefreshIcon fill='#999B9F' />}
        text='Refresh'
        type='text'
        disabled={true}
        justifyContent='flex-start'
      />
    </WizrFlexLayout>
  )
}

const FileActionPopOver = ({ detail }: IFolderActionPopOver): JSX.Element => {
  const { showModal, hideModal } = useWizrModalContext()
  const params = useParams()
  const tenantDetails = useGetTenantDetails()
  const [popoverOpen, setPopoverOpen] = useState(false)

  return (
    <Row style={{ justifyContent: 'space-evenly' }}>
      <Col>
        <Popover
          content={
            <FileActionPopOverContent
              onEditAction={() => {
                setPopoverOpen(false)
                showModal(MODAL_TYPES.ADD_TAGS, {
                  fileDetail: detail,
                  onSubmit: async (tagValues: any) => {
                    await dispatchUpdateFile({
                      file_id: detail?.file_id,
                      file_name: detail?.file_name,
                      file_tags: tagValues,
                    })
                    if (params?.id) {
                      await dispatchListFiles(params?.id)
                    }
                    hideModal()
                  },
                  onCancel: () => hideModal(),
                })
              }}
              onDeleteAction={() => {
                setPopoverOpen(false)
                showModal(MODAL_TYPES.DELETE_FILE, {
                  fileName: detail?.file_name,
                  onDeleteConfirm: async () => {
                    hideModal()
                    const payload = [`${detail?.file_id}`]
                    await dispatchDeleteFile(payload)
                    if (params?.id) {
                      dispatchListFiles(params?.id)
                    }
                  },
                  onCancel: hideModal,
                })
              }}
              details={detail}
              onDownloadAction={async () => {
                console.log('detail', detail);

                const folderId = params?.id
                if (!folderId) return
                const pathPrefix = detail?.upload_status === 'failed' || detail?.upload_status === 'Failed' ? 'error' : 'inarchive'
                const payload = {
                  container_id: 3,
                  path: `${pathPrefix}/${folderId}/${detail?.created_at}/${detail?.file_name}`,
                }
                await dispatchGenerateSASTokenForDownload(payload, detail?.file_name)
              }}
            />
          }
          title=''
          trigger='click'
          open={popoverOpen}
          onOpenChange={setPopoverOpen}
        >
          <StyledButton icon={<MoreIcon />} text='' type='text' style={{ height: '40px', width: '40px', borderRadius: '50px' }} />
        </Popover>
      </Col>
    </Row>
  )
}
export default FileActionPopOver

const StyledButton = styled(WizrButton)`
border-radius: 50%;
width: 20px;
height: 20px;
padding-right: 8px;
justify-content: center;
align-items: center;
  /* Default styles */
  path {
    stroke: #999B9F; /* Default stroke color */
    transition: stroke 0.3s ease; /* Smooth transition for color change */
  }

  /* Hover styles */
  &:hover path {
    stroke: #1D1F22
  }
`;
